import { CharacterCount } from '@tiptap/extension-character-count';
import { Heading } from '@tiptap/extension-heading';
import Highlight from '@tiptap/extension-highlight';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import { Link } from '@tiptap/extension-link';
import { ListItem } from '@tiptap/extension-list-item';
import { Mathematics } from '@tiptap/extension-mathematics';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import TableRow from '@tiptap/extension-table-row';
import { TaskItem } from '@tiptap/extension-task-item';
import { TaskList } from '@tiptap/extension-task-list';
import { TextAlign } from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import { Underline } from '@tiptap/extension-underline';
import type { Node as PMNode } from '@tiptap/pm/model';
import { StarterKit } from '@tiptap/starter-kit';

import { ColorExtension } from './ColorExtension';
import FontSize from './FontSizeExtension';
import ImageBlock from './ImageBlock';
import { SlashCommand } from './SlashCommandExtension';
import { TableCellWithColwidth } from './TableCellWithColwidth';
import { TableHeaderWithColwidth } from './TableHeaderWithColwidth';
import { TableWithColgroup } from './TableWithColgroup';

interface TipTapExtensionKitOption {
	ai: {
		openTableInsertDialog: () => void;
		openImageUploadDialog: () => void;
	};
	mathEditor?: {
		onInlineMathClick: (node: PMNode, pos: number) => void;
		onBlockMathClick: (node: PMNode, pos: number) => void;
	};
	disabledSlashCommands?: string[];
}

export const TipTapExtensionKit = ({
	ai,
	mathEditor,
	disabledSlashCommands,
}: TipTapExtensionKitOption) => [
	Mathematics.configure({
		inlineOptions: mathEditor ? { onClick: mathEditor.onInlineMathClick } : undefined,
		blockOptions: mathEditor ? { onClick: mathEditor.onBlockMathClick } : undefined,
	}),
	StarterKit.configure({
		heading: false,
		listItem: false,
		horizontalRule: false,
	}),
	Underline,
	Placeholder,
	TextAlign.configure({
		types: ['heading', 'paragraph'],
	}),
	Heading.configure({
		levels: [1, 2, 3],
	}),
	TaskList,
	TaskItem.configure({
		nested: true,
	}),
	ListItem,
	CharacterCount.configure({
		limit: 10000,
	}),
	SlashCommand.configure({
		ai,
		disabledCommands: disabledSlashCommands,
		mathEditor,
	}),
	TextStyle,
	FontSize,
	Link.configure({
		openOnClick: false,
	}),
	ColorExtension,
	Highlight.configure({ multicolor: true }),
	ImageBlock,
	HorizontalRule,
	Superscript,
	Subscript,
	TableWithColgroup.configure({
		resizable: true,
		HTMLAttributes: {
			class: 'tiptap-table',
		},
	}),
	TableRow,
	TableHeaderWithColwidth,
	TableCellWithColwidth,
];

export default TipTapExtensionKit;
